/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "e.g. A documentary about wildlife in the Amazon rainforest..." |
*
* @param {Content_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const content_description_placeholder = /** @type {((inputs?: Content_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Par exemple, un documentaire sur la faune sauvage de la forêt amazonienne...")
	if (locale === "de") return /** @type {LocalizedString} */ ("z. B. eine Dokumentation über die Tierwelt im Amazonas-Regenwald...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ad esempio, un documentario sulla fauna selvatica nella foresta pluviale amazzonica...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Например, документальный фильм о дикой природе амазонских тропических лесов...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por ejemplo, un documental sobre la vida salvaje en la selva amazónica...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("例如：一部关于亚马逊雨林野生动物的纪录片……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("例：アマゾンの熱帯雨林に生息する野生動物に関するドキュメンタリー…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उदाहरण के लिए, अमेज़न वर्षावन में वन्यजीवों पर आधारित एक वृत्तचित्र...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por exemplo, um documentário sobre a vida selvagem na floresta amazônica...")
	return /** @type {LocalizedString} */ ("e.g. A documentary about wildlife in the Amazon rainforest...")
});